import { makeStyles } from "@mui/styles";
import { COLORS } from "../../constant/colors";

const useStyles = makeStyles((theme) => ({
  loaderSec: {
    width: "100%",
    textAlign: "center",
  },
  loader: {
    width: 50,
    height: 50,
  },
  breadcrumb: {
    fontSize: 14,
  },
  breadcrumbLink: {
    color: COLORS.primary,
    fontSize: 14,
    '&:hover': {
      color: COLORS.black
    }
  },
  singleProductSec: {
    padding: "50px 0",
  },
  productName: {
    fontSize: 36,
    fontFamily: "Poppins",
    fontWeight: "600",
    textAlign: "left",
    color: COLORS.textPrimary,
    marginBottom: "15px",
    "@media (max-width: 768px)": {
      fontSize: 24,
    },
    '@media (max-width: 475px)': {
      fontSize: 20,
      marginBottom: '10px',
    }
  },
  ratingStar: {
    '@media (max-width: 475px)': {
      fontSize: '14px !important',
    }
  },
  priceSec: {
    display: "flex",
    alignItems: "center",
  },
  del: {
    fontSize: 17,
    color: COLORS.lightGrey1,
    fontFamily: "Poppins",
    display: "block",
    fontWeight: "500",
    marginRight: 15,
    "@media (max-width: 768px)": {
      fontSize: 17,
    },
    "@media (max-width: 576px)": {
      fontSize: 14,
    },
  },
  price: {
    fontSize: 26,
    color: COLORS.primary,
    fontFamily: "Poppins",
    letterSpacing: "20",
    "@media (max-width: 768px)": {
      fontSize: 20,
    },
    "@media (max-width: 576px)": {
      fontSize: 16,
    },
  },
  brandName: {
    marginTop: 8,
  },
  skuSec: {
    marginBottom: 5,
  },
  unavailable: {
    color: "#ff0000",
  },
  btnBock: {
    marginBottom: 15,
    display: "flex",
    alignItems: "center",
    gap: 15,
    "@media (max-width: 500px)": {
      marginTop: 10,
    },
  },
  inputBtnSec: {
    marginTop: 20,
  },
  weightSec: {
    display: "flex",
    flexDirection: "column",
    marginRight: 10,
    marginTop: 10,
    gap: "10px",
  },
  weight: {
    fontWeight: "500",
    color: COLORS.black,
    fontSize: "16px",
    marginBottom: "5px  !important",
  },
  btnRow: {
    display: "flex",
    flexWrap: "wrap",
  },
  btnTab: {
    marginRight: 10,
  },
  weightBtn: {
    border: `1px solid ${COLORS.secondary}`,
    color: COLORS.darkGrey1,
    padding: "10px 20px",
    borderRadius: "20px",
    fontSize: 13,
    fontWeight: "500",
    transition: "all 0.3s ease-in-out",
    cursor: "pointer",
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: COLORS.secondary,
      color: "white",
      borderColor: COLORS.secondary,
      transform: "translateY(-1px)",
      boxShadow: "0 2px 8px rgba(179, 148, 2, 0.3)",
    },
    "@media (max-width: 576px)": {
      fontSize: 11,
      padding: "6px 12px",
    },
  },
  weightBtnActive: {
    backgroundColor: COLORS.secondary,
    color: "white",
    borderColor: COLORS.secondary,
    boxShadow: "0 2px 8px rgba(179, 148, 2, 0.3)",
  },
  quantitySec: {
    display: "flex",
    alignItems: "center",
    marginTop: 10,
  },
  quantityBox: {
    marginLeft: 10,
  },
  buyNowBtnSec: {
    flex: '1',
  },
  buyNow: {
    marginRight: 10,
    background: "#fff !important",
    color: `${COLORS.secondary} !important`,
    border: `1px solid ${COLORS.secondary} !important`,
    "&:hover": {
      background: `${COLORS.secondary} !important`,
      color: `${COLORS.white} !important`,
    },
  },
  ingredientsText: {
    color: COLORS.darkGrey1,
  },
  ingredientsValue: {
    fontSize: 14,
  },
  similarProductsSec: {
    padding: "50px 0",
    textAlign: "center",
  },
  sectionHeading: {
    fontSize: "2rem !important",
    fontWeight: 700,
    color: COLORS.textPrimary,
    marginBottom: '30px !important',
    fontFamily: "'Poppins', sans-serif",
    textAlign: "center",
  },
  productRow: {
    alignItems: "center",
    justifyItems: "center",
    margin: "0 auto",
  },
  descriptionUl: {
    textTransform: "capitalize",
    paddingLeft: "7px !important",
    "& li": {
      position: "relative",
      paddingLeft: 10,
      marginBottom: "10px !important",
      "&::before": {
        content: '""',
        position: "absolute",
        width: 6,
        height: 6,
        transform: "translateY(-50%) rotate(39deg)",
        background: COLORS.lightGrey2,
        top: 12,
        left: -5,
      },
    },
  },
  nutritionImg: {
    maxWidth: 200,
    width: "100%",
  },
  tabTitle: {
    fontSize: "16px !important",
    fontFamily: "Poppins !important",
    "@media (max-width: 991px)": {
      fontSize: "14px !important",
      marginTop: "30px !important",
    },
  },
  // Accordion styles
  accordionItem: {
    boxShadow: "none !important",
    border: "none !important",
    borderBottom: `1px solid ${COLORS.borderLight} !important`,
    marginBottom: "0 !important",
    borderRadius: "0 !important",
    padding: "8px 0 !important",
    "&:before": {
      display: "none",
    },
    "&.Mui-expanded": {
      margin: "0 !important",
    },
  },
  accordionSummary: {
    backgroundColor: "transparent !important",
    borderRadius: "0 !important",
    minHeight: "50px !important",
    padding: "0 !important",
    "&.Mui-expanded": {
      minHeight: "50px !important",
      borderRadius: "0 !important",
    },
    "& .MuiAccordionSummary-content": {
      margin: "8px 0 !important",
      "&.Mui-expanded": {
        margin: "8px 0 !important",
      },
    },
  },
  accordionTitle: {
    fontSize: "16px !important",
    fontFamily: "Poppins !important",
    fontWeight: "600 !important",
    color: COLORS.textPrimary,
    "@media (max-width: 991px)": {
      fontSize: "14px !important",
    },
  },
  accordionDetails: {
    padding: "12px 0 16px 0 !important",
    backgroundColor: COLORS.white,
    borderRadius: "0 !important",
  },
  accordionText: {
    fontSize: "14px",
    color: COLORS.textPrimary,
    lineHeight: "1.6",
    marginBottom: "15px",
    "&:last-child": {
      marginBottom: "0",
    },
  },
  accordionLink: {
    color: COLORS.primary,
    textDecoration: "underline !important",
    "&:hover": {
      color: COLORS.secondary,
    },
  },
  accordionHeading: {
    fontSize: "16px",
    fontWeight: "600",
    color: COLORS.textPrimary,
    marginBottom: "10px",
  },
  accordionParagraph: {
    fontSize: "14px",
    color: COLORS.textPrimary,
    marginBottom: "15px",
    lineHeight: "1.5",
  },
  // Payment Partners Section
  paymentPartnersSection: {
    padding: "20px 0",
    borderBottom: `1px solid ${COLORS.primary}`,
    display: "none",
    justifyContent: "space-between",
    alignItems: "center",
  },
  paymentPartnersTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: COLORS.textPrimary,
    margin: '0 !important',
    textAlign: "center",
    "@media (max-width: 768px)": {
      fontSize: "16px",
    },
  },
  paymentPartnersImage: {
    maxWidth: 350,
  },
  nutritionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    '@media (max-width: 479px)': {
      flexDirection: 'column',
    }
  },
  nutiLeftCol: {
    width: '40%',
    '@media (max-width: 479px)': {
      width: '100%',
    }
  },
  nutiRightCol: {
    width: '60%',
    paddingLeft: '35px',
    '@media (max-width: 479px)': {
      width: '100%',
      paddingLeft: '0px',
      marginTop: '30px',
    }
  },
  divider: {
    width: 1,
    backgroundColor: COLORS.lightGrey,
    '@media (max-width: 479px)': {
      display: 'none',
    }
  },
  // New styles for redesigned product page
  productImageSection: {
    position: 'relative',
    marginBottom: '20px',
  },
  mainImageContainer: {
    width: '100%',
    border: `1px solid ${COLORS.lightGrey}`,
    borderRadius: '20px',
    overflow: 'hidden',
    marginBottom: '15px',
    aspectRatio: '250/219',
  },
  imageWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
    '&:hover $zoomIcon': {
      opacity: '1',
      transform: 'scale(1.1)',
    },
  },
  mainImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    cursor: 'zoom-in',
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.02)',
    },
  },
  zoomIcon: {
    position: 'absolute',
    pointerEvents: 'none',
    top: '15px',
    right: '15px',
    width: '40px',
    height: '40px',
    backgroundColor: '#fff',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: '0',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    zIndex: '10',
    '& i': {
      color: '#000',
      fontSize: '16px',
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      transform: 'scale(1.1)',
    },
    '@media (max-width: 768px)': {
      width: '35px',
      height: '35px',
      top: '10px',
      right: '10px',
      '& i': {
        fontSize: '14px',
      },
    },
  },
  thumbnailContainer: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
    justifyContent: 'center',
    '@media (max-width: 768px)': {
      justifyContent: 'flex-start',
    },
  },
  thumbnailItem: {
    flex: '0 0 auto',
  },
  thumbnail: {
    width: '60px',
    height: '60px',
    objectFit: 'cover',
    border: `2px solid ${COLORS.lightGrey}`,
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      borderColor: COLORS.primary,
      transform: 'scale(1.05)',
    },
    '@media (max-width: 768px)': {
      width: '50px',
      height: '50px',
    },
  },
  activeThumbnail: {
    borderColor: COLORS.primary,
    boxShadow: `0 0 0 2px ${COLORS.primary}20`,
  },
  productDetailsSection: {
    padding: '20px',
    '@media (max-width: 768px)': {
      padding: '0',
      marginTop: '20px',
    },
  },
  productHeader: {
    marginBottom: '15px',
  },
  priceSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    flexWrap: 'wrap',
  },
  originalPrice: {
    display: 'flex',
    alignItems: 'center',
    color: COLORS.lightGrey1,
    textDecoration: 'line-through !important',
    fontSize: '18px',
    '@media (max-width: 768px)': {
      fontSize: '16px',
    },
  },
  currentPrice: {
    display: 'flex',
    alignItems: 'center',
    color: COLORS.primary,
    fontSize: '24px',
    fontWeight: '600',
    '@media (max-width: 768px)': {
      fontSize: '18px',
    },
  },
  currency: {
    fontSize: '1.2em',
    marginRight: '2px',
  },
  mrpPrice: {
    fontSize: '1.2em',
  },
  sellingPrice: {
    fontSize: '1.2em',
  },
  discountBadge: {
    backgroundColor: COLORS.primary,
    color: 'white',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  productInfo: {
    marginBottom: '20px',
  },
  infoItem: {
    marginBottom: '20px',
    '&:last-child': {
      marginBottom: '0',
    },
  },
  infoLabel: {
    fontWeight: '500',
    color: COLORS.black,
    marginRight: '10px',
    minWidth: '80px',
  },
  infoValue: {
    color: COLORS.black,
  },
  stockStatus: {
    fontWeight: '600',
    padding: '2px 8px',
    borderRadius: '4px',
    fontSize: '12px',
    textTransform: 'uppercase',
  },
  inStock: {
    color: '#00b300',
  },
  outOfStock: {
    color: '#ff0000',
    backgroundColor: '#ffe8e8',
  },
  weightSection: {
    marginBottom: '30px',
  },
  quantitySection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  quantityLabel: {
    fontWeight: '500',
    color: COLORS.black,
    fontSize: '16px',
  },
  quantityControls: {
    display: 'inline-flex',
    width: 'fit-content',
    alignItems: 'center',
    border: `1px solid ${COLORS.secondary}`,
    borderRadius: '25px',
    overflow: 'hidden',
    backgroundColor: 'white',
  },
  quantityBtn: {
    width: '40px',
    height: '40px',
    border: 'none',
    backgroundColor: 'transparent',
    color: COLORS.darkGrey1,
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    '&:hover:not(:disabled)': {
      backgroundColor: COLORS.primary,
      color: 'white',
    },
    '&:disabled': {
      opacity: '0.5',
      cursor: 'not-allowed',
    },
  },
  quantityValue: {
    width: '60px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    color: COLORS.darkGrey1,
    fontWeight: '600',
  },
  actionButtons: {
    display: 'flex',
    gap: '15px',
    marginBottom: '25px',
    '@media (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  addCartButton: {
    flex: '1',
    '& .btn-sec': {
      width: '100%',
    },
  },
}));

export default useStyles;
